import axios from "../axios";

const findInCart = (cart, id) => {
  return cart.find((cartItem) => cartItem.id === id);
};

const getUserCart = async () => {
  return await new Promise(function (resolve, reject) {
    axios
      .get("/cart")
      .then((response) => {
        resolve(Object.values(response.data.cart));
      })
      .catch(reject);
  });
};

export { findInCart, getUserCart };
